import loadable from '@loadable/component';

export const SkinAnalyser = loadable(() => import('./SkinAnalyser'), {
  ssr: true,
});
